import React, { useState, useEffect } from 'react';
import { BrowserRouter, Switch } from 'react-router-dom';
import { Home, Dashboard, ConfirmResetPassword } from './pages';
import * as ROUTES from './constants';
import { IsUserRedirect, ProtectedRoute } from './helpers';
import { useAuthListener } from './hooks';
import { useFirebaseQuotaContext } from './context';
import { Core } from './components';
import { HomeProvider } from './context';

export default function App() {
  const { user } = useAuthListener();
  const { firebaseQuota } = useFirebaseQuotaContext();
  const [showError, setShowError] = useState(false);

  useEffect(() => {
    if (firebaseQuota && firebaseQuota != '') setShowError(true);
  }, [firebaseQuota]);

  return (
    <>
      <Core.ForceAlert color={'#ea4e3d'} showBox={showError} zIndex={99999}>
        {firebaseQuota}
      </Core.ForceAlert>

      <BrowserRouter>
        <Switch>
          <IsUserRedirect
            exact
            user={user}
            loggedInPath={ROUTES.DASHBOARD}
            path={ROUTES.HOME}
          >
            <HomeProvider>
              <Home />
            </HomeProvider>
          </IsUserRedirect>

          <ProtectedRoute user={user} exact path={ROUTES.DASHBOARD}>
            <Dashboard />
          </ProtectedRoute>

          <IsUserRedirect
            exact
            user={user}
            loggedInPath={ROUTES.DASHBOARD}
            path={ROUTES.CONFIRM_RESET_PASSWORD}
          >
            <ConfirmResetPassword />
          </IsUserRedirect>
        </Switch>
      </BrowserRouter>
    </>
  );
}
